import "./dashboard-navigation.styles.css";
import Logo from "../../assets/images/logo.png";
import { dashboardNavList } from "../../data/dashboardNavList";
import { Link } from "react-router-dom";
import { useState } from "react";
import { IoLocationSharp } from "react-icons/io5";
import { CiLogout } from "react-icons/ci";
import { MdOutlineKeyboardDoubleArrowLeft } from "react-icons/md";

const DashboardNavigation = ({ isOpen, toggleNavigation }) => {
  const [selectedItemId, setSelectedItemId] = useState(dashboardNavList[0]?.id || null);

  const handleItemClick = (id) => {
    setSelectedItemId(id);
  };

  return (
    <div className={`dashboard-navigation ${isOpen ? "open-dashboard" : ""}`}>
      <button
        className="dashboard-close-button"
        onClick={toggleNavigation} // تغییر وضعیت باز/بسته بودن
      >
        <MdOutlineKeyboardDoubleArrowLeft className="dashboard-close-button-icon" />
      </button>
      <img src={Logo} alt="Logo" className="dashboard-navigation-logo" />
      <ul className="dashboard-list-wrapper">
        <strong className="dashboard-title">
          <IoLocationSharp className="dashboard-title-icon" />
          All Devices
        </strong>
        {dashboardNavList.map((item) => (
          <li
            key={item.id}
            className={`dashboard-list-item ${selectedItemId === item.id ? "selected-item" : ""}`}
            onClick={() => handleItemClick(item.id)}
          >
            <Link to={item.linkTo} className="dashboard-item-link">
              <span className="select-field">
                <span className="select-field-span"></span>
              </span>
              {item.item}
            </Link>
          </li>
        ))}
      </ul>
      <button className="log-out-button">
        <CiLogout className="log-out-button-icon" />
        Log out
      </button>
    </div>
  );
};

export default DashboardNavigation;
